var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "counter-form",
    attrs: { visible: _vm.showModal, size: "large", title: _vm.title },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close-popup")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _vm.counterLoaded
                ? _c("div", { staticClass: "form counter-customisation" }, [
                    _c("div", { staticClass: "dialog__default--container" }, [
                      _c(
                        "span",
                        { staticClass: "dialog__default--example gray-60" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Exemple de rendu")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "dialog__default--preview" }, [
                        _vm._v(_vm._s(_vm.preview))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-row" }, [
                      _c(
                        "div",
                        { staticClass: "mr-3 w-1" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "dialog__default--label",
                              attrs: { for: "root" }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Racine")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            class: [{ "has-error": "root" in _vm.errors }],
                            attrs: { maxlength: "10" },
                            model: {
                              value: _vm.counter.root,
                              callback: function($$v) {
                                _vm.$set(_vm.counter, "root", $$v)
                              },
                              expression: "counter.root"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mr-3 w-2" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "dialog__default--label",
                              attrs: { for: "dateformat" }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Date")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "wp-10",
                              model: {
                                value: _vm.counter.dateformat,
                                callback: function($$v) {
                                  _vm.$set(_vm.counter, "dateformat", $$v)
                                },
                                expression: "counter.dateformat"
                              }
                            },
                            _vm._l(_vm.dateFormats, function(format) {
                              return _c("el-option", {
                                key: format.value,
                                attrs: {
                                  label: format.name,
                                  value: format.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mr-3 w-1" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "dialog__default--label",
                              attrs: { for: "identcounter" }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Compteur")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            class: [{ "has-error": "counter" in _vm.errors }],
                            attrs: {
                              maxlength: _vm.counter.identcounterzerofill
                            },
                            model: {
                              value: _vm.counter.identcounter,
                              callback: function($$v) {
                                _vm.$set(_vm.counter, "identcounter", $$v)
                              },
                              expression: "counter.identcounter"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mr-3 w-1" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "dialog__default--label",
                              attrs: { for: "identcounterzerofill" }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Longueur")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              on: { change: _vm.updateLengthCounter },
                              model: {
                                value: _vm.counter.identcounterzerofill,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.counter,
                                    "identcounterzerofill",
                                    $$v
                                  )
                                },
                                expression: "counter.identcounterzerofill"
                              }
                            },
                            _vm._l(_vm.counterWidth, function(size) {
                              return _c("el-option", {
                                key: size,
                                attrs: { label: size, value: size }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mr-3 w-2" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "dialog__default--label",
                              attrs: { for: "glue" }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Séparateur")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "wp-10",
                              model: {
                                value: _vm.counter.glue,
                                callback: function($$v) {
                                  _vm.$set(_vm.counter, "glue", $$v)
                                },
                                expression: "counter.glue"
                              }
                            },
                            _vm._l(_vm.builtGlues, function(glue) {
                              return _c("el-option", {
                                key: glue.value,
                                attrs: { label: glue.name, value: glue.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-2" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "dialog__default--label",
                              attrs: { for: "style" }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("Ordre")) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.counter.style,
                                callback: function($$v) {
                                  _vm.$set(_vm.counter, "style", $$v)
                                },
                                expression: "counter.style"
                              }
                            },
                            _vm._l(_vm.identStyles, function(ident) {
                              return _c("el-option", {
                                key: ident.value,
                                attrs: { label: ident.name, value: ident.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-row" }, [
                      "root" in _vm.errors
                        ? _c("div", { staticClass: "error-msg" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.errors.root) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      "counter" in _vm.errors
                        ? _c("div", { staticClass: "error-msg ml-3" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.errors.counter) +
                                "\n                    "
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "loader-container prelative mt-5" },
                    [_c("preloader", { attrs: { display: true } })],
                    1
                  )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close-popup")
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.save"),
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }